import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from '4all-ui/components/Select';
import { styles } from '4all-ui/styles';
import {
  parseStatus,
  PAYMENT_MONEY,
  STATUS_CANCELLED,
  ID_ORDER_TYPE,
} from '../../../../../../helpers/constants';
import parsePayment from '../../../../../../helpers/payment';
import HelperStatus from '../../../../../../helpers/status';
import Formats from '../../../../../../helpers/formats';
import CancelModal from '../CancelModal';
import * as styled from './style';
import ArrowIcon from '../../../../../../components/Icons/Arrow';

class Header extends Component {
  state = {
    statusSelected: {},
    status: [],
    showModal: false,
  };

  componentWillMount() {
    const { data } = this.props;
    const status = HelperStatus.getStatusByOrderType(data.idOrderType);

    this.statusUpdate(data);
    this.setState({ status });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.statusUpdate(nextProps.data);
    }
  }

  statusUpdate = data => {
    const status = parseStatus(data.status);

    this.setState({ statusSelected: this.setDotConfigurationToStatus(status) });
  };

  selectStatus = statusSelected => {
    const { data, putOrder } = this.props;
    const cancelOrder = 200;

    if (statusSelected.id === cancelOrder) {
      this.setState({ showModal: true });
    } else {
      this.setState({ statusSelected: this.setDotConfigurationToStatus(statusSelected) });
      putOrder(data.idOrder, { status: statusSelected.id });
    }

    if (!statusSelected) {
      const select = {
        id: new Date().getTime(),
        label: 'Não identificado',
        color: '',
      };

      this.setState({ statusSelected: select });
    }
  };

  renderCardMessage = ({ id, card, message, change = null }) => {
    if (card && card.length) {
      return `${message} - ${card}`;
    }

    if (id === PAYMENT_MONEY) {
      if (change) {
        return (
          <Fragment>
            <styled.OrderMethodText>{message}</styled.OrderMethodText>
            <styled.OrderMethodText>{change}</styled.OrderMethodText>
          </Fragment>
        );
      }

      return message;
    }

    return null;
  };

  renderPayment = (method, status, paymentStatus) => {
    const { data } = this.props;
    const payment = parsePayment(method, status, paymentStatus);
    const card = Object.keys(data.brand).length ? data.brand.name : '';
    let message = '';
    let change = null;

    if (payment.id === PAYMENT_MONEY) {
      message = payment.name;

      if (data.change) {
        change = `Troco para ${Formats.formatCurrency(data.change.toString())}`;
      }
    } else {
      message = Object.keys(data.paymentMethod).length ? data.paymentMethod.name : '';
    }

    return (
      <styled.OrderTypeContainer>
        <styled.OrderTypeItem>
          {payment.icon}

          <styled.OrderTypeDescription color={payment.color}>
            <styled.OrderMethod>
              {this.renderCardMessage({
                card,
                id: payment.id || 0,
                message,
                change,
              })}
            </styled.OrderMethod>
            <styled.OrderStatus>{payment.label}</styled.OrderStatus>
          </styled.OrderTypeDescription>
        </styled.OrderTypeItem>
        {data.scheduledTime && (
          <styled.OrderScheduled>
            <span>Agendamento:</span>
            <p>{Formats.formatDate(data.scheduledTime)}</p>
          </styled.OrderScheduled>
        )}
      </styled.OrderTypeContainer>
    );
  };

  setDotConfigurationToStatus = status => ({
    ...status,
    value: status.id,
    ...HelperStatus.addDotInformation(status),
  });

  render() {
    const { statusSelected, status, showModal } = this.state;
    const { data, putOrder, orderDisplay, idOrderType, order } = this.props;
    const isCancelled = statusSelected.id === STATUS_CANCELLED;

    return (
      <Fragment>
        <styled.OrderDetailsBox className="order-details" colSize={8}>
          <styled.OrderDetailsItem>
            <styled.OrderId>
              {data.idOrder} <styled.OrderDate>{data.date}</styled.OrderDate>
            </styled.OrderId>

            <styled.OrderDisplay>
              <styled.OrderDisplayFirst>
                {orderDisplay.first} {order.deliveryPersonallyObservation ? ' - Receber em Mãos' : ''}
              </styled.OrderDisplayFirst>

              {idOrderType !== ID_ORDER_TYPE.retiradaBaldao &&
                ID_ORDER_TYPE.voucher !== 4 &&
                ID_ORDER_TYPE.pedidoNaComanda !== 6 && (
                  <Fragment>
                    <ArrowIcon direction="right" />
                    <styled.OrderDisplayLast>{orderDisplay.last}</styled.OrderDisplayLast>
                  </Fragment>
                )}
            </styled.OrderDisplay>
          </styled.OrderDetailsItem>

          {this.renderPayment(data.paymentMethod, data.status, data.paymentStatus)}

          <Select
            value={statusSelected}
            id="button-status-change"
            onChange={value => this.selectStatus(value)}
            options={status.map(item => this.setDotConfigurationToStatus(item))}
            optionsListHeight="200px"
            containerCustomStyles={{
              backgroundColor: statusSelected.bgColor,
              borderRadius: styles.borders.RADIUS_1,
              cursor: 'pointer',
              boxShadow: '0 0 10px 3px rgba(0, 0, 0, 0.05)',
            }}
            dotOptions={{
              singleValueDot: false,
            }}
            customValueStyles={{
              color: statusSelected.color || '#fff',
              fontSize: styles.fontSizes.SIZE_6,
              fontWeight: 700,
            }}
            customDropdownIndicatorStyles={{
              paddingRight: 15,
              display: isCancelled ? 'none' : 'flex',
            }}
            customValueContainerStyles={{
              paddingLeft: 13,
              '& > .select__single-value--is-disabled': {
                left: '50%',
                transform: 'translateY(-50%) translateX(-50%)',
              },
            }}
            customPlaceholderStyles={{
              color: styles.colors.WHITE,
              fontSize: styles.fontSizes.SIZE_6,
              fontWeight: 700,
            }}
            height="44px"
            width="200px"
            iconColor={statusSelected.color || '#fff'}
            closeMenuOnSelect
            borderColor={
              statusSelected.borderColor ? statusSelected.borderColor : statusSelected.bgColor
            }
            isSearchable={false}
            disabled={isCancelled}
          />
        </styled.OrderDetailsBox>

        <CancelModal
          putOrder={putOrder}
          data={data}
          show={showModal}
          close={() => this.setState({ showModal: false })}
        />
      </Fragment>
    );
  }
}

Header.propTypes = {
  data: PropTypes.object,
  putOrder: PropTypes.func,
  merchant: PropTypes.object,
  orderDisplay: PropTypes.object,
  idOrderType: PropTypes.number,
  order: PropTypes.object,
};

export default Header;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/Header/index.js